module.exports = __webpack_public_path__ + "static/img/tipsImg.30a9599c.png";